import * as React from 'react';
export const SISvg = React.forwardRef(function SISvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M1.994 2A1.997 1.997 0 0 0 0 4.005V7h16V4.005A2 2 0 0 0 14.006 2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 6V4.005A1 1 0 0 0 14.006 3H1.994A.997.997 0 0 0 1 4.005V6H0V4.005C0 2.894.893 2 1.994 2h12.012A2 2 0 0 1 16 4.005V6h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 10v2c0 1.105.895 2 1.994 2h12.012A1.992 1.992 0 0 0 16 12v-2H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M3 4h4v2.5a2 2 0 1 1-4 0V4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M3 4h4v2H3z',
      }),
    ),
  );
});
SISvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SI = {
  category: 'flag',
  colorable: false,
  name: 'SI',
  svg: SISvg,
};
